export default __webpack_public_path__ + "static/media/prev-artisan.a9c3f8cd.jpg";